import TextBlock from '../../model/TextBlock'

class Codeblock extends TextBlock {}

Codeblock.type = "codeblock"

export default Codeblock
